import React from 'react'
import { Form, Input, Alert } from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'
import { useI18n } from '@/shared/i18n'

interface SensitiveFieldInputProps {
  name: string | string[]
  label: string
  placeholder?: string
  hasValue: boolean
  isAdmin?: boolean
  rules?: any[]
  inputType?: 'password' | 'text'
  fieldType?: 'password' | 'webhook' | 'apiKey' | 'url'
}

const SensitiveFieldInput: React.FC<SensitiveFieldInputProps> = ({
  name,
  label,
  placeholder,
  hasValue,
  isAdmin = false,
  rules = [],
  inputType = 'password',
  fieldType = 'password'
}) => {
  const { t } = useI18n('modules')

  // 根据字段类型生成消息
  const getFieldMessages = () => {
    switch (fieldType) {
      case 'webhook':
        return {
          setMessage: t('settings.messages.webhookSet'),
          notSetMessage: t('settings.messages.webhookNotSet'),
          adminDescription: t('settings.messages.webhookAdminDescription'),
          userDescription: t('settings.messages.webhookUserDescription'),
          placeholderText: t('settings.messages.webhookPlaceholder')
        }
      case 'apiKey':
        return {
          setMessage: t('settings.messages.apiKeySet'),
          notSetMessage: t('settings.messages.apiKeyNotSet'),
          adminDescription: t('settings.messages.apiKeyAdminDescription'),
          userDescription: t('settings.messages.apiKeyUserDescription'),
          placeholderText: t('settings.messages.apiKeyPlaceholder')
        }
      case 'url':
        return {
          setMessage: t('settings.messages.urlSet'),
          notSetMessage: t('settings.messages.urlNotSet'),
          adminDescription: t('settings.messages.urlAdminDescription'),
          userDescription: t('settings.messages.urlUserDescription'),
          placeholderText: t('settings.messages.urlPlaceholder')
        }
      case 'password':
      default:
        return {
          setMessage: t('settings.messages.passwordSet'),
          notSetMessage: t('settings.messages.passwordNotSet'),
          adminDescription: t('settings.messages.passwordAdminDescription'),
          userDescription: t('settings.messages.passwordUserDescription'),
          placeholderText: t('settings.messages.passwordPlaceholder')
        }
    }
  }

  const messages = getFieldMessages()

  return (
    <>
      <Form.Item
        name={name}
        label={label}
        rules={rules}
        help={
          hasValue ? (
            <Alert
              message={messages.setMessage}
              description={
                isAdmin
                  ? messages.adminDescription
                  : messages.userDescription
              }
              type="info"
              showIcon
              icon={<InfoCircleOutlined />}
              style={{ marginTop: 8 }}
            />
          ) : (
            <Alert
              message={messages.notSetMessage}
              description={isAdmin ? t('settings.messages.enterFieldToEnable', { label }) : t('settings.messages.contactAdminToSet', { label })}
              type="warning"
              showIcon
              icon={<InfoCircleOutlined />}
              style={{ marginTop: 8 }}
            />
          )
        }
      >
        {inputType === 'password' ? (
          <Input.Password
            placeholder={placeholder || messages.placeholderText}
            disabled={!isAdmin && hasValue}
          />
        ) : (
          <Input
            placeholder={placeholder || messages.placeholderText}
            disabled={!isAdmin && hasValue}
          />
        )}
      </Form.Item>
    </>
  )
}

export default SensitiveFieldInput